import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getFillRateByCompanyCsv } from 'api/pulse/fillRateByCompany'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useFillRateByCompanyDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_fill_rate_by_company', {
        filters: query,
      })
      const data = await getFillRateByCompanyCsv(query)
      fileDownload(data, 'fill_rate_by_company.csv')
    },
  })
}
